import Swal from 'sweetalert2'
export default async function alertaError(title){
    //alert sweet 2
    Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: title,
      showConfirmButton: false,
      timer: 1500
    })
  }